import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LoaderService } from '../services/loader.service';
import { AppSettingService } from '../services/app-setting.service';
import { PrimeNG } from 'primeng/config';
import { FoldersService } from '../services/folders.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Ajudacatory Materials';
  loading: boolean = false;
  lastIndexUpdate = '';
  currentYear = (new Date()).getFullYear();

  constructor(private primeng: PrimeNG, private router: Router, private loaderService: LoaderService, 
    private asSvc: AppSettingService, private folderSvc: FoldersService) {
  }

  ngOnInit(): void {
    this.primeng.ripple.set(true);
    // this.folderSvc.loadInitialFolders();
    this.subscribeLoader();
    this.updateLastIndex();
  }

  updateLastIndex() {
    this.asSvc.getLastIndexObservable().subscribe((lastIndex) => {
      this.lastIndexUpdate = lastIndex;
    });
  }

  subscribeLoader() {
    this.loaderService.isLoading.subscribe((v) => {
      this.loading = v;
    });
  }
}
